/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfDesignConfigurationDto } from "../models/AjaxResponseOfDesignConfigurationDto";
import type { AjaxResponseOfDesignLogoUploadDto } from "../models/AjaxResponseOfDesignLogoUploadDto";
import type { AjaxResponseOfDesignPreferencesDto } from "../models/AjaxResponseOfDesignPreferencesDto";
import type { AjaxResponseOfListOfDesignCatalogItemDto } from "../models/AjaxResponseOfListOfDesignCatalogItemDto";
import type { AjaxResponseOfListOfDesignSoundDto } from "../models/AjaxResponseOfListOfDesignSoundDto";
import type { DesignLogoUploadInput } from "../models/DesignLogoUploadInput";
import type { UpdateDesignPreferencesInput } from "../models/UpdateDesignPreferencesInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class DesignConfigurationAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfDesignConfigurationDto Success
   * @throws ApiError
   */
  public getConfiguration(): CancelablePromise<AjaxResponseOfDesignConfigurationDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design/configuration",
    });
  }
  /**
   * @returns AjaxResponseOfDesignPreferencesDto Success
   * @throws ApiError
   */
  public getPreferences(): CancelablePromise<AjaxResponseOfDesignPreferencesDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design/preferences",
    });
  }
  /**
   * @returns AjaxResponseOfDesignPreferencesDto Success
   * @throws ApiError
   */
  public updatePreferences({
    requestBody,
  }: {
    requestBody?: UpdateDesignPreferencesInput;
  }): CancelablePromise<AjaxResponseOfDesignPreferencesDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/design/preferences",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfDesignLogoUploadDto Success
   * @throws ApiError
   */
  public createLogoUpload({
    requestBody,
  }: {
    requestBody?: DesignLogoUploadInput;
  }): CancelablePromise<AjaxResponseOfDesignLogoUploadDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/design/logo-upload",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfListOfDesignCatalogItemDto Success
   * @throws ApiError
   */
  public getTemplates(): CancelablePromise<AjaxResponseOfListOfDesignCatalogItemDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design/catalog/templates",
    });
  }
  /**
   * @returns AjaxResponseOfListOfDesignCatalogItemDto Success
   * @throws ApiError
   */
  public getMotions(): CancelablePromise<AjaxResponseOfListOfDesignCatalogItemDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design/catalog/motions",
    });
  }
  /**
   * @returns AjaxResponseOfListOfDesignSoundDto Success
   * @throws ApiError
   */
  public getSounds(): CancelablePromise<AjaxResponseOfListOfDesignSoundDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/design/catalog/sounds",
    });
  }
}
